'use client'

import {
  type AbstractIntlMessages,
  type AppConfig,
  NextIntlClientProvider,
} from 'next-intl'

import type { ChildrenProps } from '../types'

import { DEFAULT_TIMEZONE } from '../constants'
import { handleError } from '../helpers/translations'

type Props = {
  translations: AbstractIntlMessages
  locale?: AppConfig['Locale']
} & ChildrenProps
export default function TranslationsProvider({
  children,
  locale,
  translations,
}: Props) {
  return (
    <NextIntlClientProvider
      locale={locale}
      messages={translations ?? {}}
      timeZone={DEFAULT_TIMEZONE}
      onError={handleError}
    >
      {children}
    </NextIntlClientProvider>
  )
}
